import React from "react";
import {
  Container,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
} from "@mui/material";
import { useIntl, defineMessages } from "react-intl";
import { all, create } from "modules/software-employee/services";
import { formatDate } from "shared/parsers/date";
import { ISoftwareEmployee } from "../types";
import Timer from "./Timer";

const messages = defineMessages({
  title: { id: "software.employee.title" },
  expired: { id: "software.employee.expired" },
  generateNewPassword: { id: "software.employee.generate.new.password" },
  password: { id: "password" },
  inUseQuestion: { id: "software.employee.in.use" },
  createdAt: { id: "created.at" },
  expireAt: { id: "expire.at" },
});

const SoftwareEmployee: React.FC = () => {
  const { formatMessage } = useIntl();
  const [data, setData] = React.useState<ISoftwareEmployee[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleReport = React.useCallback(async () => {
    const { status, data: dataReturn } = await all();
    if (status === 200) {
      setLoading(false);
      setData(dataReturn);
    }
  }, []);

  const handleNewPassword = React.useCallback(async () => {
    setLoading(true);
    const { status } = await create();
    if ([200, 201].includes(status)) {
      handleReport();
    }
  }, [handleReport]);

  React.useEffect(() => {
    handleReport();
  }, [handleReport]);

  return (
    <Container maxWidth="lg">
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ marginBottom: 5, overflowX: "auto" }}
      >
        <Typography variant="h5" component="h4" fontWeight="bold">
          {formatMessage(messages.title)}
        </Typography>
        <Button
          variant="outlined"
          onClick={() => handleNewPassword()}
          disabled={loading}
        >
          {!loading ? (
            <>{formatMessage(messages.generateNewPassword)}</>
          ) : (
            <CircularProgress size={20} color="info" />
          )}
        </Button>
      </Grid>
      <Grid container>
        <Paper
          sx={{
            width: "100%",
            borderRadius: 4,
            boxShadow:
              "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
          }}
        >
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>{formatMessage(messages.password)}</TableCell>
                  <TableCell>{formatMessage(messages.inUseQuestion)}</TableCell>
                  <TableCell>{formatMessage(messages.createdAt)}</TableCell>
                  <TableCell>{formatMessage(messages.expireAt)}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item, index) => (
                  <TableRow key={`idxs${index}`}>
                    <TableCell>{item.password}</TableCell>
                    <TableCell>{item.in_use ? "Sim" : "Não"}</TableCell>
                    <TableCell>
                      {formatDate(new Date(item.created_at))}
                    </TableCell>
                    <TableCell>
                      <Timer
                        createdAt={item.created_at}
                        expiresAt={item.expire_at}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Container>
  );
};

export { SoftwareEmployee };
